export default {
    "fsm_messages": "FSM Messages",
    "fsm_routes": "FSM Routes",
    "fsm_settings": "FSM Settings"
};